import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { FirebaseListObservable, FirebaseObjectObservable } from 'angularfire2/database';

import { Subscription } from 'rxjs/Subscription';

import { Event } from '../models/event';
import { EventFeature } from '../models/event-feature';
import { User } from '../models/user';

import { EventFeatureService } from '../services/event-feature.service';

@Component({
  selector: 'app-events-detail',
  templateUrl: './events-detail.component.html',
  styleUrls: ['./events-detail.component.css']
})
export class EventsDetailComponent implements OnInit, OnDestroy {

  company$?: FirebaseObjectObservable<User | null>;
  event$?: FirebaseObjectObservable<Event | null>;
  eventFeatures$?: FirebaseListObservable<EventFeature[] | null>;
  eventSubscription?: Subscription;

  constructor(
    private route: ActivatedRoute,
    private eventFeatureService: EventFeatureService
  ) { }

  ngOnInit() {
    this.route.data.subscribe((data: {
      user$: FirebaseObjectObservable<User | null> | null,
      event$: FirebaseObjectObservable<Event | null> | null,
    }) => {
      if (!data.user$ || !data.event$) {
        return;
      }

      this.company$ = data.user$;
      this.event$ = data.event$;

      if (this.eventSubscription) {
        this.eventSubscription.unsubscribe();
      }

      this.eventSubscription = this.event$.subscribe((event: Event | null) => {
        if (event) {
          this.eventFeatures$ = this.eventFeatureService.getEventFeatures(event.id);
        }
      });
    });
  }

  ngOnDestroy() {
    if (this.eventSubscription) {
      this.eventSubscription.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// D:/ThinkBIT/work-projects/confe/hosting/src/app/events/events-detail.component.ts